import classes from './NoteCard.module.css';
import React, { useState, useContext, useEffect } from 'react';
import Modal from './Modal';
import bin from '../assets/svg/delete.svg';
import pallet from '../assets/svg/pallet.svg';
import archive from '../assets/svg/archive.svg';
import NotesContext from '../store/notes-context';

export default function NoteCard(props) {
  const [showOptions, setShowOptions] = useState(false);
  const [editedTitle, setEditedTitle] = useState('');
  const [editedNote, setEditedNote] = useState('');
  const [visibility, setVisibility] = useState(true);

  const noteCtx = useContext(NotesContext);
  const note = noteCtx.getNotes(props.note.id);
  console.log(noteCtx.color, props.note.color);

  useEffect(() => {
    setEditedNote(note.note);
    setEditedTitle(note.title);
    // return () => {
    //   cleanup;
    // };
  }, [note.title, note.note]);

  const deleteNote = (id) => {
    noteCtx.deleteNote(id);
  };

  const onEditTitleChange = (e) => {
    setEditedTitle(e.target.value);
  };

  const onEditNoteChange = (e) => {
    setEditedNote(e.target.value);
  };

  const onEditFormSubmitted = (e) => {
    e.preventDefault();
    noteCtx.editNote({
      id: note.id,
      title: editedTitle,
      note: editedNote,
    });
    toggleModal();
  };

  const toggleModal = (e) => {
    console.log('MODAL TOGGLED');
    setShowOptions((prevState) => !prevState);
    setVisibility((prevState) => !prevState);
  };

  let id = note.id;

  const onChangeColor = (color) => {
    noteCtx.setColor({ id, color });
  };

  const cardClass = visibility
    ? `${classes.card} ${classes[`${props.note.color}`]} ${classes.visible}`
    : `${classes.card} ${classes.hidden}`;

  let cardBorder = {
    border: 'none',
  };

  if (note.color === 'default') {
    cardBorder = {
      border: '1px solid #5f6368',
    };
  }

  return (
    <>
      <div className={cardClass} style={cardBorder} onClick={toggleModal}>
        <div className={classes.inner}>{props.children}</div>
        <div className={classes.btn}>
          <button
            onClick={(e) => {
              e.cancelBubble = true;
              if (e.stopPropagation) e.stopPropagation();
            }}
            className={classes['color-pallet']}
          >
            <img src={pallet} alt="" />
            <div className={classes.colors}>
              <div
                className={`${classes.color} ${classes.default}`}
                // onClick={(e) => {
                //   e.cancelBubble = true;
                //   if (e.stopPropagation) e.stopPropagation();
                // }}
                onClick={(e) => {
                  e.cancelBubble = true;
                  if (e.stopPropagation) e.stopPropagation();
                  onChangeColor('default');
                }}
              ></div>
              <div
                className={`${classes.color} ${classes.red}`}
                onClick={() => {
                  onChangeColor('red');
                }}
              ></div>
              <div
                className={`${classes.color} ${classes.orange}`}
                onClick={() => {
                  onChangeColor('orange');
                }}
              ></div>
              <div
                className={`${classes.color} ${classes.yellow}`}
                onClick={() => {
                  onChangeColor('yellow');
                }}
              ></div>
              <div
                className={`${classes.color} ${classes.green}`}
                onClick={() => {
                  onChangeColor('green');
                }}
              ></div>
              <div
                className={`${classes.color} ${classes.teal}`}
                onClick={() => {
                  onChangeColor('teal');
                }}
              ></div>
              <div
                className={`${classes.color} ${classes.blue}`}
                onClick={() => {
                  onChangeColor('blue');
                }}
              ></div>
              <div
                className={`${classes.color} ${classes['dark-blue']}`}
                onClick={() => {
                  onChangeColor('dark-blue');
                }}
              ></div>
              <div
                className={`${classes.color} ${classes.purple}`}
                onClick={() => {
                  onChangeColor('purple');
                }}
              ></div>
              <div
                className={`${classes.color} ${classes.pink}`}
                onClick={() => {
                  onChangeColor('pink');
                }}
              ></div>
              <div
                className={`${classes.color} ${classes.brown}`}
                onClick={() => {
                  onChangeColor('brown');
                }}
              ></div>
              <div
                className={`${classes.color} ${classes.grey}`}
                onClick={() => {
                  onChangeColor('grey');
                }}
              ></div>
            </div>
          </button>

          <button
            onClick={(e) => {
              e.cancelBubble = true;
              if (e.stopPropagation) e.stopPropagation();
            }}
          >
            <img src={archive} alt="" />
          </button>

          <button
            onClick={(e) => {
              e.cancelBubble = true;
              if (e.stopPropagation) e.stopPropagation();
              deleteNote(note.id);
            }}
          >
            <img src={bin} alt="delete" />
          </button>
        </div>
      </div>
      {showOptions && (
        <Modal setShowForm={toggleModal}>
          <form className={classes.modal} onSubmit={onEditFormSubmitted}>
            <input
              type="text"
              value={editedTitle}
              onChange={onEditTitleChange}
            />
            <textarea
              name=""
              id=""
              cols="10"
              rows="20"
              value={editedNote}
              onChange={onEditNoteChange}
            ></textarea>
            <button>Save</button>
          </form>
        </Modal>
      )}
    </>
  );
}
